import React, {Component} from "react";
import {Button, Divider, Form, Input, Layout, message, Modal, Pagination, Select, Table} from 'antd';

import Header from '../../components/header'
import Left from '../../components/leftAd'

import './score.less'
import '../../assets/css/admin.less'
import {reqClassList, reqDeleteScore, reqScoreList} from "../../api";
import axios from "axios";

const {Content} = Layout;
const {Option} = Select;


/**
 * 学生成绩路由组件
 */
export class Score extends Component {

    state = {
        ModalText: '',
        confirmLoading: false,
        visible: false,
        confirmDirty: false,
        autoCompleteResult: [],
        student: {},
        studentList: [],
        classList: [],
        paperList: [],
        selectValue: 0,
        selectType: 0,
        paperName: '',
        total: 0,
        page: 1,
        size: 10,
        fuzzyName: '',
        deleteVisible: false,
        deleteStudent: {},
        selectedRowsKeys: [],
        userId: '',
        testPaperNo: '',
        disabled:false
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            deleteVisible: false
        });
    };

    handleDelete = () => {
        this.setState({
            deleteVisible: true,
        });
    };

    getScoreList = async (data) => {
        const result = await reqScoreList(data);
        // console.log(result)
        if (result.code === '000000') {
            this.setState({
                studentList: result.data.rows,
                page: result.data.page,
                total: result.data.total
            })
        } else {
            message.error(result.data.msg);
        }
    };

    getClassList = async (data) => {
        const result = await reqClassList(data);
        if (result.code === '000000') {
            this.setState({
                classList: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    };

    showDeleteModal = (record) => {
        this.setState({
            deleteVisible: true,
            deleteStudent: record
        });
    };

    deleteStudent = async (record) => {
        const result = await reqDeleteScore(record.userId, record.testPaperNo);
        if (result.code === '000000') {
            message.success("删除成功");
            this.getScoreList({
                page: 1,
                size: 10
            });
            this.handleCancel();
        }
    };

    selectChange = e => {
        this.setState({
            selectValue: e
        })
    };
    selectTypeChange = e => {
        this.setState({
            selectType: e
        });
        if(e === 'MOCK'){
            this.setState({
                disabled:true
            })
        }else {
            this.setState({
                disabled:false
            })
        }
    };

    searchList = async () => {
        const name = document.getElementById("search_input").value;
        const paperName = document.getElementById("search_paper").value;
        let data = {
            page: 1,
            size: 10
        };
        if (this.state.selectValue !== '' && this.state.selectValue !== 0) {
            data["classRoomId"] = this.state.selectValue;
        }
        if (this.state.selectType !== '' && this.state.selectType !== 0) {
            data["type"] = this.state.selectType;
        }
        if (name&&name !== '') {
            data["name"] = name;
            this.setState({
                fuzzyName: name
            })
        }else {
            this.setState({
                fuzzyName:''
            })
        }
        if (paperName&&paperName !== '') {
            data["paperName"] = paperName;
            this.setState({
                paperName: paperName
            })
        }else {
            this.setState({
                paperName:''
            })
        }
        this.getScoreList(data);
    };
    clearSearch = async () => {
        sessionStorage.clear();
        window.location.reload();
    };
    pageClick = async page => {
        const name = document.getElementById("search_input").value;
        const paperName = document.getElementById("search_paper").value;
        let data = {
            page: page,
            size: 10
        };
        if (this.state.selectValue !== '' && this.state.selectValue !== 0) {
            data["classRoomId"] = this.state.selectValue;
        }
        if (this.state.selectType !== '' && this.state.selectType !== 0) {
            data["type"] = this.state.selectType;
        }
        if (paperName !== '') {
            data["paperName"] = paperName;
        }
        if (name !== '') {
            data["name"] = name;
        }
        this.getScoreList(data);
    };

    itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total) => {
        return '共' + total + '条记录/每页' + this.state.size + '条';
    };

    downloadScore = async (record) => {
        let urls = global.constant.baseUrl + 'test/' + record.userId + '/' + record.testPaperNo + '/download';
        axios.get(urls,
            {
                withCredentials: true,
                crossDomain: true,
                responseType: 'blob'    // 设置响应数据类型
            })
            .then(res => {
                let url = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.target = "_blank";
                link.download = record.type === "MOCK" ? "模拟训练" : "正式考试" + "-" + record.testPaperName + "-" + record.userName + ".pdf";
                document.getElementById("batchSave").appendChild(link);
                link.click();
            }).catch(err => {
            // console.log(err);
        });
    };

    saveScore = async () => {
        let arr = [];
        let ids = this.state.userId.split(",");
        let nos = this.state.testPaperNo.split(",");
        for (let i = 0; i < ids.length; i++) {
            arr[i] = {
                "userId": ids[i].split(".")[0] - 0,
                "paperNo": nos[i]
            };
        }
        let urls = global.constant.baseUrl + "test/download";
        message.info("正在下载，请稍后(模拟试卷不能下载)");
        axios.post(urls, arr,
            {
                withCredentials: true,
                crossDomain: true,
                responseType: 'blob'    // 设置响应数据类型
            })
            .then(res => {
                //  如果支持微软的文件下载方式(ie10+浏览器)
                if (window.navigator.msSaveBlob) {
                    try {
                        const blobObject = new Blob([res.data], {type: 'application/pdf'});
                        window.navigator.msSaveBlob(blobObject,"BulkDownload.pdf");
                    } catch (e) {
                        // console.log(e);
                    }
                } else {
                    //  其他浏览器
                    let url = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
                    let link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = url;
                    document.getElementById("batchSave").appendChild(link);
                    link.download = "BulkDownload.pdf";
                    link.click();
                }
            }).catch(err => {
            // console.log(err);
        });
    };

    componentDidMount = async () => {
        this.getScoreList({
            page: 1,
            size: 10
        });
        this.getClassList({
            page: 1,
            size: 100,
            status:true
        });
        document.getElementsByClassName("ant-menu-item")[2].click();
    };


    render() {

        const {total, page, selectedRowKeys, studentList, classList, size, deleteVisible, deleteStudent,disabled} = this.state;

        const columns = [
            {
                title: '编号',
                dataIndex: 'id',
                key: 'id',
                render: (text, record, index) => (
                    <span>{(this.state.page - 1) * this.state.size + index + 1}</span>
                ),
            },
            {
                title: '考试类型',
                dataIndex: 'testPaperType',
                key: 'testPaperType',
                render: (text, record) => (
                    <span>
                    {record.testPaperType === 'MOCK' ?
                        <span>模拟训练</span> :
                        <span>正式考试</span>}
                </span>
                )
            },
            {
                title: '试卷名称',
                dataIndex: 'testPaperName',
                key: 'testPaperName',
            },
            {
                title: '用户名/学号',
                dataIndex: 'userName',
                key: 'userName',
            },
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '班级',
                dataIndex: 'classRoomName',
                key: 'classRoomName',
            },
            {
                title: '成绩',
                dataIndex: 'scores',
                key: 'scores',
                className: 'scores',
                align: 'center',
            },
            {
                title: '操作',
                key: 'action',
                align: 'center',
                render: (text, record) => (
                    <span>
                        {record.testPaperType === 'MOCK' ?
                            <a><span>无</span></a>:
                            <a id={record.id} name={'save'}
                               download={record.testPaperType === "MOCK" ? "模拟训练" : "正式考试" + "-" + record.testPaperName + "-" + record.userName + ".pdf"}
                               href={global.constant.baseUrl + 'test/' + record.userId + '/' + record.testPaperNo + '/download'}><span>存档</span></a>}
                </span>
                ),
            },
        ];
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                let name = [];
                let id = [];
                for (let i = 0; i < selectedRows.length; i++) {
                    if(selectedRows[i].testPaperType!=="MOCK"){
                        name.push(selectedRows[i].testPaperNo);
                        id.push(selectedRows[i].userId);
                    }
                }
                this.setState({
                    userId: id.toString(),
                    testPaperNo: name.toString(),
                    selectedRowKeys: selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Left>Left</Left>
                    <Content>
                        <div className='table_right'>
                            <div className='table_search'>
                                <Button className="batch_delete" onClick={this.saveScore}>批量存档</Button>
                                <Button className='batch_delete clear' onClick={this.clearSearch.bind(this)}>重置</Button>
                                <Button className='batch_delete search' onClick={this.searchList.bind(this)}>检索</Button>
                                <div className='search_box'>
                                    <label>试卷名称:</label>
                                    <Input id='search_paper' className="search_name" style={{width: 160}} disabled={disabled}/>
                                </div>
                                <div className='search_box'>
                                    <label>考试类型:</label>
                                    <Select id='search_select'
                                            style={{width: 160}} className="search_type"
                                            onChange={this.selectTypeChange.bind(this)}>
                                        <Option key={0} value={0}>全部</Option>
                                        <Option key={1} value={"FORMAL"}>正式考试</Option>
                                        <Option key={2} value={"MOCK"}>模拟考试</Option>
                                    </Select>
                                </div>
                                <div className='search_box'>
                                    <label>班级:</label>
                                    <Select id='search_select' className="search_class"
                                            style={{width: 160}}
                                            onChange={this.selectChange.bind(this)}>
                                        <Option key={0} value={0}>全部</Option>
                                        {
                                            classList&&classList.map((item, index) => (
                                                <Option key={index} value={item.id}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                                <div className='search_box'>
                                    <label>学生姓名:</label>
                                    <Input id='search_input' className="search_name" style={{width: 160}}/>
                                </div>
                            </div>
                            <Table rowSelection={rowSelection} columns={columns} pagination={false}
                                   dataSource={studentList}
                                   rowKey={studentList => (studentList.userId + "." + studentList.id)}
                            />
                            <Pagination total={total} current={page} pageSize={size} onChange={this.pageClick}
                                        itemRender={this.itemRender} showTotal={this.showTotal}/>
                        </div>
                        <Modal
                            title="提示"
                            visible={deleteVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deleteStudent.bind(this, deleteStudent)}
                            onCancel={this.handleCancel}>
                            <div>确定删除吗？</div>
                        </Modal>
                        <span id="batchSave"/>

                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapScore = Form.create()(Score);
export default WrapScore